import AccountingConnection from "../../entities/accountingConnection";

/**
 * AccountingConnection actions
 *
 * Call order:
 *
 * ACCOUNTINGCONNECTION_SAVE_QUEUE:	adds the item to the save queue
 * --> ACCOUNTINGCONNECTION_SAVE:	modifies the state
 * --> ACCOUNTINGCONNECTION_SAVE_SUCCESS: if all went well
 * --> ACCOUNTINGCONNECTION_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ACCOUNTINGCONNECTION_SAVE_QUEUE is during the call to ACCOUNTINGCONNECTION_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ACCOUNTINGCONNECTION_FETCH_ONE_QUEUE: any = 'ACCOUNTINGCONNECTION_FETCH_ONE_QUEUE';
export const ACCOUNTINGCONNECTION_FETCH_SUCCESS: any = 'ACCOUNTINGCONNECTION_FETCH_SUCCESS';
export const ACCOUNTINGCONNECTION_FETCH_FAILURE: any = 'ACCOUNTINGCONNECTION_FETCH_FAILURE';
export const ACCOUNTINGCONNECTION_FETCH_ONE_SUCCESS: any = 'ACCOUNTINGCONNECTION_FETCH_ONE_SUCCESS';
export const ACCOUNTINGCONNECTION_FETCH_ONE_FAILURE: any = 'ACCOUNTINGCONNECTION_FETCH_ONE_FAILURE';

export const ACCOUNTINGCONNECTION_SAVE: any = 'ACCOUNTINGCONNECTION_SAVE';
export const ACCOUNTINGCONNECTION_SAVE_QUEUE: any = 'ACCOUNTINGCONNECTION_SAVE_QUEUE';
export const ACCOUNTINGCONNECTION_SAVE_SUCCESS: any = 'ACCOUNTINGCONNECTION_SAVE_SUCCESS';
export const ACCOUNTINGCONNECTION_SAVE_FAILURE: any = 'ACCOUNTINGCONNECTION_SAVE_FAILURE';

export const ACCOUNTINGCONNECTION_SAVE_MANY: any = 'ACCOUNTINGCONNECTION_SAVE_MANY';
export const ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE: any = 'ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE';
export const ACCOUNTINGCONNECTION_SAVE_MANY_SUCCESS: any = 'ACCOUNTINGCONNECTION_SAVE_MANY_SUCCESS';
export const ACCOUNTINGCONNECTION_SAVE_MANY_FAILURE: any = 'ACCOUNTINGCONNECTION_SAVE_MANY_FAILURE';

export const ACCOUNTINGCONNECTION_REMOVE: any = 'ACCOUNTINGCONNECTION_REMOVE';
export const ACCOUNTINGCONNECTION_REMOVE_QUEUE: any = 'ACCOUNTINGCONNECTION_REMOVE_QUEUE';
export const ACCOUNTINGCONNECTION_REMOVE_SUCCESS: any = 'ACCOUNTINGCONNECTION_REMOVE_SUCCESS';
export const ACCOUNTINGCONNECTION_REMOVE_FAILURE: any = 'ACCOUNTINGCONNECTION_REMOVE_FAILURE';

export const ACCOUNTINGCONNECTION_RESTORE: any = 'ACCOUNTINGCONNECTION_RESTORE';
export const ACCOUNTINGCONNECTION_RESTORE_QUEUE: any = 'ACCOUNTINGCONNECTION_RESTORE_QUEUE';
export const ACCOUNTINGCONNECTION_RESTORE_SUCCESS: any = 'ACCOUNTINGCONNECTION_RESTORE_SUCCESS';
export const ACCOUNTINGCONNECTION_RESTORE_FAILURE: any = 'ACCOUNTINGCONNECTION_RESTORE_FAILURE';

export const ACCOUNTINGCONNECTION_RESTORE_MANY: any = 'ACCOUNTINGCONNECTION_RESTORE_MANY';
export const ACCOUNTINGCONNECTION_REMOVE_MANY: any = 'ACCOUNTINGCONNECTION_REMOVE_MANY';

/* Fetch actions */
export const fetchAccountingConnectionSuccess = (accountingConnections: AccountingConnection[], partial: boolean, lastFetch: number) => ({type: ACCOUNTINGCONNECTION_FETCH_SUCCESS, accountingConnections, partial, lastFetch});
export const fetchAccountingConnectionFailure = (err: any) => {
		console.error('AccountingConnectionAction: fetchAccountingConnectionFailure', err);
		return {type: ACCOUNTINGCONNECTION_FETCH_FAILURE, err};
};
export const fetchOneAccountingConnectionQueue = (accountingConnectionId: string) => ({type: ACCOUNTINGCONNECTION_FETCH_ONE_QUEUE, accountingConnectionId});
export const fetchOneAccountingConnectionSuccess = (accountingConnection: AccountingConnection) => ({type: ACCOUNTINGCONNECTION_FETCH_ONE_SUCCESS, accountingConnection});
export const fetchOneAccountingConnectionFailure = (id: string, err: any) => {
		console.error('AccountingConnectionAction: fetchOneAccountingConnectionFailure', err);
		return {type: ACCOUNTINGCONNECTION_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveAccountingConnection = (accountingConnection: AccountingConnection) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE action', accountingConnection?.id);
    return {type: ACCOUNTINGCONNECTION_SAVE, accountingConnection};
}
export const saveAccountingConnectionQueue = (accountingConnection: AccountingConnection) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE_QUEUE action', accountingConnection?.id);
    return {type: ACCOUNTINGCONNECTION_SAVE_QUEUE, accountingConnection};
}
export const saveAccountingConnectionSuccess = (accountingConnection: AccountingConnection) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE_SUCCESS action', accountingConnection?.id);
    return {type: ACCOUNTINGCONNECTION_SAVE_SUCCESS, accountingConnection};
}
export const saveAccountingConnectionFailure = (accountingConnection: AccountingConnection, status: number, message: string) => {
    console.warn(`⮂ ACCOUNTINGCONNECTION_SAVE_FAILURE error saving accountingConnection: HTTP ${status}: ${message}`, accountingConnection?.id);
    return {type: ACCOUNTINGCONNECTION_SAVE_FAILURE, accountingConnection, status, message};
};

/* SaveMany actions */
export const saveManyAccountingConnections = (accountingConnections: AccountingConnection[]) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE_MANY action', accountingConnections?.map(accountingConnection => accountingConnection?.id).join(','));
    return {type: ACCOUNTINGCONNECTION_SAVE_MANY, accountingConnections};
}
export const saveManyAccountingConnectionsQueue = (accountingConnections: AccountingConnection[]) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE action', accountingConnections?.map(accountingConnection => accountingConnection.id).join(','));
    return {type: ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE, accountingConnections};
}

export const saveManyAccountingConnectionsSuccess = (accountingConnections: AccountingConnection[]) => {
    // console.debug('⮂ ACCOUNTINGCONNECTION_SAVE_MANY_SUCCESS action', accountingConnections?.map(accountingConnection => accountingConnection.id).join(','));
    return {type: ACCOUNTINGCONNECTION_SAVE_MANY_SUCCESS, accountingConnections};
}
export const saveManyAccountingConnectionsFailure = (accountingConnections: AccountingConnection[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ACCOUNTINGCONNECTIONS_FAILURE Error saving accountingConnections: HTTP ${status}: ${message}`, accountingConnections?.map(accountingConnection => accountingConnection.id).join(','));
		return {type: ACCOUNTINGCONNECTION_SAVE_MANY_FAILURE, accountingConnections, status, message};
};

/* Remove actions */
export const removeAccountingConnection = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_REMOVE, accountingConnection });
export const removeAccountingConnectionQueue = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_REMOVE_QUEUE, accountingConnection });
export const removeAccountingConnectionSuccess = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_REMOVE_SUCCESS, accountingConnection });
export const removeAccountingConnectionFailure = (accountingConnection: AccountingConnection, status: number, message: string) => {
	console.error(`Redux: removeAccountingConnectionFailure Error removing accountingConnection: HTTP ${status}: ${message}`);
	return ({ type: ACCOUNTINGCONNECTION_REMOVE_FAILURE, accountingConnection, status, message });
};

/* Restore actions */
export const restoreAccountingConnection = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_RESTORE, accountingConnection });
export const restoreAccountingConnectionQueue = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_RESTORE_QUEUE, accountingConnection });
export const restoreAccountingConnectionSuccess = (accountingConnection: AccountingConnection) => ({ type: ACCOUNTINGCONNECTION_RESTORE_SUCCESS, accountingConnection });
export const restoreAccountingConnectionFailure = (accountingConnection: AccountingConnection, status: number, message: string) => {
	console.error(`Redux: restoreAccountingConnectionFailure Error restoring accountingConnection: HTTP ${status}: ${message}`);
	return ({ type: ACCOUNTINGCONNECTION_RESTORE_FAILURE, accountingConnection, status, message });
};

/* RestoreMany actions */
export const restoreManyAccountingConnections = (accountingConnections: AccountingConnection[]) => ({ type: ACCOUNTINGCONNECTION_RESTORE_MANY, accountingConnections });

/* RemoveMany actions */
export const removeManyAccountingConnections = (accountingConnections: AccountingConnection[]) => ({ type: ACCOUNTINGCONNECTION_REMOVE_MANY, accountingConnections });